module.exports = __webpack_public_path__ + "img/popup-close.7ab21692.svg";